import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, BellIcon, UserCircleIcon } from 'lucide-react';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
interface TopBarProps {
  title?: string;
  showSearch?: boolean;
  notificationCount?: number;
  onSearchClick?: () => void;
  onNotificationClick?: () => void;
  onProfileClick?: () => void;
  onMenuClick?: () => void;
}
export function TopBar({
  title,
  showSearch = true,
  notificationCount = 0,
  onSearchClick,
  onNotificationClick,
  onProfileClick
}: TopBarProps) {
  return <header className="sticky top-0 z-30 bg-white border-b-2" style={{
    borderColor: OPENFINANCE_THEME.colors.borderLight,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
  }} data-id="element-1735">
      <div className="flex items-center justify-between h-16 px-4 md:px-6 max-w-7xl mx-auto" data-id="element-1736">
        {/* Left: Logo (mobile only) and Title */}
        <div className="flex items-center gap-3" data-id="element-1737">
          {/* VeloX Logo - Mobile only (sidebar hidden on mobile) */}
          <div className="flex items-center gap-2 md:hidden" data-id="element-1738">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center p-1.5" style={{
            background: `linear-gradient(135deg, ${OPENFINANCE_THEME.colors.primary500} 0%, ${OPENFINANCE_THEME.colors.primary600} 100%)`
          }} data-id="element-1739">
              <img src="https://cdn.magicpatterns.com/uploads/6ixnVN3mm3sFs3kb5m4Wow/apple-touch-icon.png" alt="VeloX" className="w-full h-full object-contain" data-id="element-1740" />
            </div>
            <span className="text-lg font-bold" style={{
            color: OPENFINANCE_THEME.colors.text,
            fontFamily: OPENFINANCE_THEME.fonts.heading
          }} data-id="element-1741">
              VeloX
            </span>
          </div>

          {/* Page Title */}
          {title && <>
              {/* Mobile: Show title after logo */}
              <div className="md:hidden flex items-center" data-id="element-1742">
                <div className="w-px h-6 mx-2" style={{
              backgroundColor: OPENFINANCE_THEME.colors.borderLight
            }} data-id="element-1743" />
                <h1 className="text-lg font-bold" style={{
              color: OPENFINANCE_THEME.colors.text,
              fontFamily: OPENFINANCE_THEME.fonts.heading
            }} data-id="element-1744">
                  {title}
                </h1>
              </div>

              {/* Desktop: Show title only (no logo, sidebar has it) */}
              <h1 className="hidden md:block text-xl font-bold" style={{
            color: OPENFINANCE_THEME.colors.text,
            fontFamily: OPENFINANCE_THEME.fonts.heading
          }} data-id="element-1745">
                {title}
              </h1>
            </>}
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-2" data-id="element-1746">
          {/* Search */}
          {showSearch && <button onClick={onSearchClick} className="p-2 rounded-lg hover:bg-gray-100 transition-colors" style={{
          color: OPENFINANCE_THEME.colors.textMuted
        }} data-id="element-1747">
              <SearchIcon className="w-5 h-5" data-id="element-1748" />
            </button>}

          {/* Notifications */}
          <button onClick={onNotificationClick} className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors" style={{
          color: OPENFINANCE_THEME.colors.textMuted
        }} data-id="element-1749">
            <BellIcon className="w-5 h-5" data-id="element-1750" />
            {notificationCount > 0 && <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} className="absolute top-1 right-1 min-w-[16px] h-[16px] rounded-full flex items-center justify-center text-[9px] font-bold text-white px-1" style={{
            backgroundColor: OPENFINANCE_THEME.colors.error
          }} data-id="element-1751">
                {notificationCount > 9 ? '9+' : notificationCount}
              </motion.div>}
          </button>

          {/* Profile */}
          <button onClick={onProfileClick} className="p-2 rounded-lg hover:bg-gray-100 transition-colors" style={{
          color: OPENFINANCE_THEME.colors.textMuted
        }} data-id="element-1752">
            <UserCircleIcon className="w-5 h-5" data-id="element-1753" />
          </button>
        </div>
      </div>
    </header>;
}